export default __webpack_public_path__ + "static/consumer-awards-bma-2018-cfab2899320d210834dffd795b5d216c.png";